module.exports = __webpack_public_path__ + "media/Video 143b.740b57ea.mp4";